// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3d1SY","insightsList":"newBusinessInsightsMenu_insightsList__1Gz0_","active":"newBusinessInsightsMenu_active__1jBCj"};